module.exports = __webpack_public_path__ + "static/media/gel.b9be0c5f.svg";